<template>
  <v-card
    flat
    class="mx-auto"
    width="400px"
  >
    <v-card-title>
      {{ title }}
    </v-card-title>

    <v-form
      v-model="complete" 
      @submit.prevent
    >
      <v-card-text>
        <v-text-field
          ref="username"
          v-model="username"
          flat
          label="Username or Email"
          :rules="[rules.required]"
        />

        <v-text-field
          v-model="password"
          label="Password"
          flat
          :rules="[rules.required]"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <forgot-password
          :energize="username && username.length >=4"
          :username="username"
        />
        <v-btn
          type="submit"
          elevation="0"
          color="primary"
          :disabled="!complete"
          @click="goLogin"
        >
          login
          <v-icon>mdi-login</v-icon>
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ForgotPassword from "./ForgotPassword.vue"

export default {
  components: { ForgotPassword },
  data() {
    return {
      title: 'Login',
      showPassword: false,
      username: null,
      password: null,
      rules: {
        required: value => !!value || 'Required!'
      },
      fails: 0,
      complete: false
    }
  },
  methods: {
    async goLogin(){
      this.$emit('busy', true)
      if (this.username && this.password) {
        let user = await this.api.post('/auth/login', {
          username: this.username,
          password: this.password,
        })
        if (user.auth) {
          this.$store.commit('account/HIDE_AUTH_DIALOG')
          this.$store.dispatch('account/LOGIN', user.auth)
        } else {
          this.fails++
          this.title = 'Login attempt failed...'
          if (this.fails > 2) {
            this.title += ` (${this.fails})`
          }
        }
        this.$emit('busy', false)
      }
    },
  },
  
}
</script>